export enum DATA_QA {
  ROOT = 'dnc-field-select',
}
